import * as actions from './actions';
import * as types from './types';

import reducer from './reducer';

export { actions, types };
export default reducer;



// WEBPACK FOOTER //
// ./src/state/auth/index.js